import React from "react";
import RemedyAddEdit from "./RemedyAddEdit";
import { AddRemedies } from "../../services/remedise.services";

const AddRemedy = () => {
    
    return (
        <div>
            <RemedyAddEdit
                initialValues={{
                    remedy_type: "",
                    name: "",
                    price: "",
                    discount: "",
                    rating: "",
                    stock: "",
                    description: "",
                    files: "",
                    attributes: {},
                }}
                onSubmit={AddRemedies}
            />
        </div>
    );
};

export default AddRemedy;
